import { gql } from "@apollo/client";

export const GET_ALL_SCAN_POSTS = gql`
  query Query {
    getScanPostsData
  }
`;
